import React, { FC,useEffect,useState } from "react";
import { useParams } from 'react-router-dom';
import { ArrowRightIcon } from "@heroicons/react/outline";
//mport LocationMarker from "components/AnyReactComponent/LocationMarker";
import AnyReactThingsComponent from "components/AnyReactComponent/AnyReactThingsComponent";
import CommentListing from "components/CommentListing/CommentListing";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import GuestsInput from "components/HeroSearchForm/GuestsInput";
import StartRating from "components/StartRating/StartRating";
import GoogleMapReact from "google-map-react";
import useWindowSize from "hooks/useWindowResize";
import moment from "moment";
import { DayPickerSingleDateController } from "react-dates";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import ButtonCircle from "shared/Button/ButtonCircle";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Input from "shared/Input/Input";
import NcImage from "shared/NcImage/NcImage";
import LikeSaveBtns from "./LikeSaveBtns";
import ModalPhotos from "./ModalPhotos";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import ExperiencesDateSingleInput from "components/HeroSearchForm/ExperiencesDateSingleInput";
import GallerySlider from "components/GallerySlider/GallerySlider";
import axios from 'axios'; 
import { Helmet } from "react-helmet";

export interface TravelInspirationsDetailPageProps {
  className?: string;
  ratioClass?: string;
}


const galleryImgs:string[]=[
  "https://pictures.tinyaway.com/filters:format(jpg)/450x300/Stories/Images/2022/05/124/Tiny-Away-800-011653897785167.jpg",
  "https://pictures.tinyaway.com/filters:format(jpg)/450x300/Stories/Images/2022/05/124/Tiny-Away-800-011653897785167.jpg",
  "https://pictures.tinyaway.com/filters:format(jpg)/450x300/Stories/Images/2022/05/124/Tiny-Away-800-011653897785167.jpg"

];
const includes_demo = [
  { name: "Set Menu Lunch on boat" },
  { name: "Express Bus From Hanoi To Halong and Return" },
  { name: "Mineral Water On Express Bus" },
  { name: "Kayak or Bamboo Boat. Life Jacket." },
  { name: "Halong Bay Entrance Ticket" },
];
console.log(11, moment());

const TravelInspirationsDetailPage: FC<TravelInspirationsDetailPageProps> = ({
  className = "",
  ratioClass = "aspect-w-3 aspect-h-2",
}) => {
  const params                                      = useParams();
  // yuo can find all params from here
  const slug                                        = Object.values(params);
  const [isOpen, setIsOpen]                         = useState(false);
  const [openFocusIndex, setOpenFocusIndex]         = useState(0);
  const [categoryName, setCategoryName]             = useState([]);
  const [infuencername, setInfuencername]           = useState([]);
  const [PHOTOS, setPHOTOS]                         = useState([]);
  const [descriptions, setDescriptions]             = useState("");
  const [address, setAddress]                       = useState("");
  const [thingsWeDid, setThingsWeDid]               = useState([]);
  const [metatitle, SetMetatitle]                   = useState([]);
  const [metadata, SetMetaData]                     = useState([]);
  const [imagePng, setImagePng]                     = useState("");
  //const [thingsHref, setThingsHref]                 = useState("");

console.log(process.env.REACT_APP_BASE_URL+'GetTravelInspirationsDetails?id='+slug);
  useEffect(() => {
   
    axios.get(process.env.REACT_APP_BASE_URL+'GetTravelInspirationsDetails?id='+slug)
 	 .then(res => {
	      	console.log(res.data); 
          setCategoryName(res.data.category_name);
          setPHOTOS(res.data.galleryImgs);
          setDescriptions(res.data.publicDescription);
          setAddress(res.data.address);
          setThingsWeDid(res.data.thingswedid);
          SetMetatitle(res.data.meta_title);
          SetMetaData(res.data.meta_data);
          setImagePng(res.data.featured_img);
    });   
  }, []);
  

  const windowSize = useWindowSize();

  const getDaySize = () => {
    if (windowSize.width <= 375) {
      return 34;
    }
    if (windowSize.width <= 500) {
      return undefined;
    }
    if (windowSize.width <= 1280) {
      return 56;
    }
    return 48;
  };

  const handleOpenModal = (index: number) => {
    setIsOpen(true);
    setOpenFocusIndex(index);
  };
  const handleCloseModal = () => setIsOpen(false);
  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap !space-y-6  Things_to_know">
       <h2 className="text-2xl font-semibold text-center text-lg">
          {categoryName}
        </h2>
        <div className="flex items-center flex-direction-column">
        </div>
        <div dangerouslySetInnerHTML={ {__html: descriptions} } />
      </div>
    );
  };
  const renderSection8 = () => {
    return (
      <div className="listingSection__wrap Things_to_know">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold text-center text-lg">THINGS WE DID</h2>
        {thingsWeDid.map((itemDetails) => (
            <div className={`flex-right ${itemDetails['classes']}`}>
                <div className="sld-Things">
                <div className="relative w-full rounded-2xl overflow-hidden">
                  <GallerySlider
                    uniqueID={`ExperiencesCard-${itemDetails['id']}`}
                    ratioClass={ratioClass}
                    galleryImgs={itemDetails['ThingsgalleryImgs']}
                  />
                </div>
                </div>
                <div className="text-Things">
                  <div>
                  <h4 className="line-clamp-1 clamp-color-size text-left"><a href={itemDetails['things_href']}>{itemDetails['title']}</a></h4>
                  <div>
                    <span className="flex items-center mb-2">
                     <span className="icon-hiking">
                      <i className="las la-hiking text-lg"></i> </span>
                     <span>{itemDetails['address']}</span> 
                    </span>
                  </div>
                  <div>
                  <span className="flex items-center mb-2 anchor-home-text">
                    <span className="loction-home-marker me-2">
                    <i className="las la-home text-lg"></i></span>
                     <span><a target={"_blank"} href={itemDetails['listing_href']} className="line-clamp-1 ">{itemDetails['listing_name']}</a></span> 
                    </span>
                  </div>
                  <div className="text-left" dangerouslySetInnerHTML={ {__html: itemDetails['description']} } />
                </div>
                </div>
            </div>
        ))}
      </div>
    );
  };
  return (
    <div
      className={`nc-ListingExperiencesDetailPage  ${className}`}
      data-nc-id="ListingExperiencesDetailPage"
    >
      {/* SINGLE HEADER */}
      <Helmet title={metatitle} meta={metadata}></Helmet>
      <>
        <header className="container  rounded-md sm:rounded-xl">
        <div className="relative ">
          <img className="w-full" src={imagePng} alt="hero" />
        </div>
        </header>
        {/* MODAL PHOTOS */}
      </>
      {/* MAIn */}
      <main className="container mt-11 flex ">
        {/* CONTENT */}
        <div className="w-full  space-y-8 lg:pr-10 lg:space-y-10">
          {renderSection1()}
          {/* {renderSection2()} */}
          {/*renderSection3()*/}
          {/*renderSectionCheckIndate()*/}
          {/*renderSection5()*/}
          {/*renderSection6()*/}
          {/* {renderSection7()} */}
          {renderSection8()}
          <div className="fixd_bottem_section"></div>
        </div>
      </main>
    </div>
  );
};

export default TravelInspirationsDetailPage;
